import { Component, OnInit, OnDestroy, Inject,ElementRef, ViewChild,EventEmitter,Output  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LeagueRegPopupComponent } from '../league-reg-popup/league-reg-popup.component';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector'; 
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { VerificationComponent } from 'src/app/verification/verification.component';
import { PhoneVerificationComponent } from 'src/app/phone-verification/phone-verification.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { UserBalanceData } from './../store/actions/appActions';

@Component({
  selector: 'app-gamepreviewpopup',
  templateUrl: './gamepreviewpopup.component.html',
  styleUrls: ['./gamepreviewpopup.component.scss']
})

export class GamepreviewpopupComponent implements OnInit, OnDestroy {
  @ViewChild('entrantsSlide') entrantsSlide: ElementRef;
  assetURL: string;
  assetUploadURL: string;
  parameters: any;
  user_id = 0;
  currentUser: any;
  infoData: any;
  scoringData: any;
  entrantsData: any;
  schedulesData: any;
  sub_result: Subscription;
  sub_userData: Subscription;
  totalSchedule = 0;
  isMobile = false;  
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>;
  verificationRef: MatDialogRef<VerificationComponent>;
  phoneVerificationRef: MatDialogRef<PhoneVerificationComponent>;
  siteUrl:string;
  joinLeagueData :any;
  prizeBoxHeight: any;
  showprev= false;
  shownext= true;
  currentEntranceShow= 6;
  darkMode= false;
  darkMode_ext= '';
  @Output() closePopupAndNavigate = new EventEmitter<any>();
  constructor(public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data,
    private spinner: NgxSpinnerService,
    private tournamentService: TournamentService,
    private deviceService: DeviceDetectorService,public gamePreviewDialogRef: MatDialogRef<GamepreviewpopupComponent>,private http: Http,private router: Router,private store: Store<AppState>) {
    this.isMobile = this.deviceService.isMobile();
    this.parameters = data;
    this.parameters.pagename = this.parameters.pagename || '';
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'_icon-dark':'';
      }
    });
    // var ip = require('what-is-my-ip-address');
    // ip.v4()
    // .then((ip) => {
    //   console.log(ip)
    // })
    // .catch((error) => {
    //   // Do you have IP v4?
    // });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser !== null) {
      this.user_id = this.currentUser.id;
      this.assetURL = `${environment.assetURL}`;
      this.assetUploadURL = `${environment.assetUploadURL}`;
      this.siteUrl = `${environment.SITE_URL}`;
      this.spinner.show();
      this.getCurrentTabData('info');
      this.getCurrentTabData('entrants');
    }
  }
 
  leagueTabChanged(event) {
    if (event.index == 1 && this.scoringData == null) {
      this.getCurrentTabData('scoring');
    }
    else if (event.index == 2 && this.schedulesData == null) {
      this.getCurrentTabData('schedules');
    }
  }

  joinLeaguePopup(league_code) {
    if (this.infoData.drafttype_id == 4){
      this.spinner.hide();
      this.closePopupAndNavigate.emit('/rankem/'+this.infoData.league_type+'/'+this.parameters.league_id);
      return false;
    } else if (this.infoData.drafttype_id == 5){
      //window.location.href = `${environment.SITE_URL}` + '/drafts/tiers/' + this.parameters.league_id;
      this.router.navigate(['/tiers'], this.parameters.league_id);
    } else {
      this.spinner.show();
      this.tournamentService.getUserLocation(this.user_id, locationData => {
        locationData['league_code'] = league_code;
        locationData['user_id'] = this.user_id;
        this.sub_result = this.tournamentService.getJoinPopUpData(locationData).subscribe(res => {
          this.spinner.hide();
          if (typeof res !== 'undefined' && res.status === 'success') {
            this.joinLeagueData = res.entities;
            if(this.joinLeagueData.join_verify_check == 1 && this.joinLeagueData.payment_verified == 'N'){
              //Profile not verified?
              this.verificationRef = this.dialog.open(VerificationComponent, {
                width: '600px',
                data: { }
              });
            } else if(this.joinLeagueData.join_verify_check == 1 && this.joinLeagueData.verify_phone == 'N'){
              //Phone number not verified?
              this.phoneVerificationRef =  this.dialog.open(PhoneVerificationComponent, {
                width: '500px',
                data: {}
              });
            } else if(this.joinLeagueData && this.infoData && (Number(this.joinLeagueData.balance) < Number(this.joinLeagueData.league_fee)) && (!this.joinLeagueData.hasTicket)){
              this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: '500px',
                data: { 'title': "Deposit", 'body': '','type':'deposit_fee','league_type':this.infoData.league_type,'name':this.infoData.name,'balance_text':this.joinLeagueData.balance_text,'entry_fee':this.joinLeagueData.entry_fee }
              });
              
              this.confirmDialogRef.afterClosed()
              .subscribe(res => {
                if (res) {
                  this.gamePreviewDialogRef.close(2); 
                }
              })
            } else {
              const remaining_people = Number(this.infoData.entrants) - Number(this.infoData.joined_entrants);
              this.leagueDialogRef = this.dialog.open(LeagueRegPopupComponent, {
                width: '500px',
                data: { 'league_code': league_code, 'draft_type': 'league','result':this.joinLeagueData,'remaining_people':remaining_people, 'league_id': this.parameters.league_id }
              });
          
              this.leagueDialogRef.afterClosed()
              .subscribe(res => {
                if (res) { 
                  this.gamePreviewDialogRef.close(1); 
                }
              })
            }
          }
          else {
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: (res.type == 'age_18') ? '500px' : '800px',
                data: { 'title': "Eligibility Warning", 'body': res.message,'type':res.type }
              });
              
              this.confirmDialogRef.afterClosed()
              .subscribe(res => {
                if (res) {
                  this.gamePreviewDialogRef.close(2); 
                }
              })
          }
        });
      });
    }
  }

  getCurrentTabData(tab_name) {
    this.sub_result = this.tournamentService.getDraftPopupData(this.parameters.league_id, this.user_id, tab_name).subscribe(res => {
      if (typeof res !== 'undefined' && res.status === 'success') {
        if (tab_name === 'info') {
          this.spinner.hide();
          this.infoData = res.entities;
        } else if (tab_name === 'scoring') {
          this.scoringData = res.entities;
        } else if (tab_name === 'entrants') {
          this.entrantsData = res.entities;
        } else if (tab_name === 'schedules') {
          this.schedulesData = res.entities;
          this.totalSchedule = (typeof res.entities.eventData !== 'undefined') ? res.entities.eventData.length : 0;
        }
      }
    });
  }
 
  confirmDialog(league_code) {
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title': this.infoData.name, 'body': 'Are you sure you want to leave this league?','type':'confirm_popup' }
    });
     
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
       if (res) {
        this.leaveLeague(league_code)
       }
    })
  }

  leaveLeague(league_code) {
    this.spinner.show();
    const second_per_pick = 0;
    const tournament_id = 0;
    this.sub_result = this.tournamentService.draftLeaveLeagueRequest({league_code, second_per_pick, tournament_id}).subscribe(res => {
      this.spinner.hide();
      if (typeof res !== 'undefined' && res.status === 'success') {
        const updated_balance = (res.entities != null && res.entities.updated_balance != null) ? res.entities.updated_balance : '0';
        /**Update store data */
        this.store.dispatch(new UserBalanceData(
          updated_balance
        ));
        this.gamePreviewDialogRef.close(2);
        if (this.parameters.pagename == 'rankem') {
          setTimeout(() => {
            this.router.navigate(['/lobby']);
          }, 400);
        }
      }
    });
  }
  
  ngOnDestroy() {
    if(this.sub_result) { this.sub_result.unsubscribe(); }
  }
  scrollToEnd(type){
    
    const sliderRef = this.entrantsSlide.nativeElement as HTMLElement;
    if(type=='Next'){
      this.currentEntranceShow++;
      sliderRef.scrollLeft += 96.18*1;
      this.showprev =true;
    }
    if(type=='Prev'){
      this.currentEntranceShow--;
    sliderRef.scrollLeft -= 96.18*1;
    this.shownext =true;
    }
    if(this.entrantsData.length==this.currentEntranceShow){
      this.shownext =false;
    }
    if(this.currentEntranceShow<7){
      this.showprev =false;
    }
  }
}
